import { TLangCode } from '../../locale/states/locale.state';
import { ModalState, initialModalState } from '../../modal/states/modal.state';
import { DeviceState, initialDeviceState } from './device.state';

/**
 * UI state interface
 */
export interface UIState {
    /**
     * Current locale
     */
    locale?: TLangCode | null;
    /**
     * Modal state
     */
    modal?: ModalState;
    /**
     * Device state
     */
    device?: DeviceState;
}

/**
 * Initial UI state
 */
export const initialUIState: UIState = {
    locale: null,
    modal: initialModalState,
    device: initialDeviceState
};
